import { MedlemskapstypeFromBackend } from '../api/medlemskapAPI';

export const medlemskapMock = (): MedlemskapstypeFromBackend[] => {
    return [
        {
            medlemskapskode: 'Enkelt',
            price: 750.0,
        },
        {
            medlemskapskode: 'EnkeltBarn',
            price: 400.0,
        },
        {
            medlemskapskode: 'EnkeltSenior',
            price: 460.0,
        },
        {
            medlemskapskode: 'Familie',
            price: 1070.0,
        },
        {
            medlemskapskode: 'HusstandVoksen',
            price: 290.0,
        },
        {
            medlemskapskode: 'HusstandBarn',
            price: 290.0,
        },
        {
            medlemskapskode: 'Livsvarig',
            price: 15000.0,
        },
    ];
};
